








import Vue from 'vue'

import modal from '@/components/common/modal/modal.vue'
import cryptoSignInfo from '@/components/roots/crypto-sign-info/crypto-sign-info.vue'

import { SignInfoRequest } from '@/data/crypto-sign-info-types/types'
// import style from './style.module.scss'

export default Vue.extend({
name: 'crypto-sign-info-page',
  components: {
    cryptoSignInfo,
    modal
  },
  props: {

  },
  mounted() {
    if(this.eventBus) {

      this.eventBus.$on('SHOW-CRYPTO-SIGN-INFO', async (data: SignInfoRequest) => {
        await this.$store.dispatch('getCryptoSignInfo', data);
        this.showCryptoSignInfo = true;
      })
      
    }
  },
  data() {
    return {
      showCryptoSignInfo: false,
      eventBus: window.VUE_EVENT_BUS_CRYPTO_SIGN_INFO,
      window: window
    // style: style
    }
  },
})
